/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkmanage2Inputs */

const en_profilelinkmanage2 = /** @type {(inputs: Profilelinkmanage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage profiles`)
};

const de_profilelinkmanage2 = /** @type {(inputs: Profilelinkmanage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile verwalten`)
};

/**
* | output |
* | --- |
* | "Manage profiles" |
*
* @param {Profilelinkmanage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkmanage2 = /** @type {((inputs?: Profilelinkmanage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkmanage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkmanage2(inputs)
	return de_profilelinkmanage2(inputs)
});
export { profilelinkmanage2 as "profileLinkManage" }